module.exports = __webpack_public_path__ + "img/角度锁定2.500577cc.svg";